import React, { Component } from "react";
import { Button, Col, Row, Space } from "antd";
import { SearchOutlined, UpOutlined, DownOutlined } from "@ant-design/icons";

import "./index.less";
import Form from "../Form";

const DEFAULT_SPAN = 6;

class QueryFilter extends Component {

  state = {
    expand: false,
  };

  formRef = React.createRef();

  query = () => {
    this.formRef.current.submit();
  };

  onExpand = () => {
    this.setState({
      ...this.state,
      expand: !this.state.expand
    });
  };

  onReset = () => {
    this.formRef.current.resetFields();
    this.props.onReset && this.props.onReset();
  };


  getExpandCount = () => {
    return 24 / (this.props.span || DEFAULT_SPAN);
  };

  showExpandBtn = () => {
    const { children } = this.props;
    const childrenCount = React.Children.count(children);
    return childrenCount > this.getExpandCount();
  };

  getActions = () => {
    const actionMap = {};
    const { actions = [], } = this.props;
    const actionsWrap = actions.map(item => {
      if (React.isValidElement(item)) {
        return item;
      }
      const { type = "", visible } = item;
      actionMap[type] = false === visible;
      return actionMap[type] ? null : item;
    }).filter(item => null !== item);
    !("query" in actionMap) && actionsWrap.push({ type: "query", });
    !("reset" in actionMap) && actionsWrap.push({ type: "reset", });
    !("expand" in actionMap) && actionsWrap.push({ type: "expand", });
    return actionsWrap;
  };

  getActionComp = (item) => {
    if (React.isValidElement(item)) {
      return item;
    }

    const { type = "", visible } = item;
    if (!item || false === visible) {
      return null;
    }

    if ("query" === type) {
      // 搜索按钮
      return (
        <Button
          type="primary"
          htmlType="submit"
          icon={< SearchOutlined />}
          loading={this.props.loading}
        >
          搜索
        </Button>
      )
    }

    if ("reset" === type) {
      // 重置按钮
      return (
        <Button
          onClick={this.onReset}
        >
          重置
        </Button>
      )
    }

    if ("expand" === type) {
      // 展开/收起按钮
      const showExpandBtn = this.showExpandBtn();
      return showExpandBtn && (
        <Button
          type="link"
          onClick={this.onExpand}
          icon={this.state.expand ? <UpOutlined /> : <DownOutlined />}
        >
          {this.state.expand ? "收起" : "展开"}
        </Button>
      )
    }

    if (type) {
      return (
        <Button
          icon={item.icon}
          loading={item.loading}
          onClick={item.onClick}
        >
          {item.title}
        </Button>
      )
    }

    return null;
  };

  render() {
    let childrenIndex = 0;
    const actions = this.getActions();
    const expandCount = this.getExpandCount();
    return (
      <div className="nano-query-filter">
        <Form
          ref={this.formRef}
          data={this.props.data}
          onFinish={this.props.onQuery}
          onValuesChange={this.props.onValuesChange}
        >
          <Row className="nano-query-filter-item">
            <div className="nano-query-filter-item-left">
              <Row wrap gutter={16}>
                {/* 搜索项 */}
                {React.Children.map(this.props.children, (child) => {
                  return child && (++childrenIndex) && React.cloneElement(child, {
                    span: this.props.span || DEFAULT_SPAN,
                    show: this.state.expand ? true : (childrenIndex - 1) < expandCount,
                    ...child.props,
                  })
                })}
              </Row>
            </div>
            <div className="nano-query-filter-item-right">
              <Form.Item style={{ textAlign: "right", }}>
                <Space>
                  {/* 限制 7 个按钮数量 */}
                  {actions.length > 0 && this.getActionComp(actions[0])}
                  {actions.length > 1 && this.getActionComp(actions[1])}
                  {actions.length > 2 && this.getActionComp(actions[2])}
                  {actions.length > 3 && this.getActionComp(actions[3])}
                  {actions.length > 4 && this.getActionComp(actions[4])}
                  {actions.length > 5 && this.getActionComp(actions[5])}
                  {actions.length > 6 && this.getActionComp(actions[6])}
                  {actions.length > 7 && this.getActionComp(actions[7])}
                </Space>
              </Form.Item>
            </div>
          </Row>
        </Form>
      </div>
    );
  };
};

class QueryFilterItem extends Component {
  render() {
    const { span = 6, key, name, show = true, label, rules = [], children, initialValue } = this.props;
    return (
      <Col
        className="nano-query-filter-item"
        key={key}
        span={span}
        style={{ display: show ? "" : "none" }}
      >
        <Form.Item
          name={name}
          label={label}
          rules={rules}
          initialValue={initialValue}
        >
          {children}
        </Form.Item>
      </Col>
    );
  };
};

QueryFilter.Item = QueryFilterItem;

export default QueryFilter;
